// modules
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

// local
// import styles from './Image.pcss';

export default class Image extends PureComponent {
  static propTypes = {
    onLoad: PropTypes.func,
    src: PropTypes.string,
  }
  
  static defaultProps = {
    onLoad: () => {},
  }
  
  onLoad = false
  complete = false
  callbackCalled = false
  
  componenWillReceiveProps(nextProps) {
    // the image will reload
    if (nextProps.src !== this.props.src) this.reset();
  }
  
  handleImageLoad = () => {
    this.onLoad = true;
    this.callbackIfLoaded();
  }
  
  saveRef = (ref) => {
    this.complete = (ref && ref.complete);
    this.callbackIfLoaded();
  }
  
  callbackIfLoaded = () => {
    if (this.isLoaded && !this.callbackCalled) {
      this.callbackCalled = true;
      this.props.onLoad();
    }
  }
  
  get isLoaded() {
    return (this.onLoad || this.complete);
  }
  
  reset = () => {
    this.onLoad = false;
    this.complete = false;
    this.callbackCalled = false;
  }
  
  render() {
    return (
      <img
        { ...this.props }
        ref={ this.saveRef }
        onLoad={ this.handleImageLoad } />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Image/index.jsx